/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useEffect, useRef } from 'react'

const Audio = ({ stream, id, isLocalStream }) => {
    const audioRef = useRef();

    useEffect(() => {
        const audio = audioRef.current
        audio.srcObject = stream

        audio.onloadedmetadata = () => {
            audio.play();
        }
    }, [stream])

    return (
        <audio
            id={id}
            style={{
                width: "100%",
                height: "100%",
            }}
            ref={audioRef}
            autoPlay
            muted={isLocalStream ? true : false}
        ></audio>
    )

}

export default Audio